var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { Typography } from '../../../foundations/typography';
import styles from './NavLink.module.scss';
/**
 * @tdr
 * @tdr-deprecated-props: label
 * @tdr-deprecated-date: 2022-08-03
 */
var NavLinkComponent = function (_a) {
    var _b;
    var _c = _a.backgroundColor, backgroundColor = _c === void 0 ? 'white' : _c, children = _a.children, className = _a.className, component = _a.component, handleOnActivate = _a.handleOnActivate, _d = _a.isActive, isActive = _d === void 0 ? false : _d, label = _a.label, linkElement = _a.linkElement, props = __rest(_a, ["backgroundColor", "children", "className", "component", "handleOnActivate", "isActive", "label", "linkElement"]);
    var linkRef = useRef(null);
    useEffect(function () {
        if (linkRef.current && isActive && handleOnActivate) {
            handleOnActivate(linkRef);
        }
        // handleOnActivate is dynamically created function which changes each render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive]);
    var Component = component || linkElement || 'a';
    var classNames = cx(styles.navLink, (_b = {},
        _b[styles.scallop] = backgroundColor === 'scallop',
        _b[styles.eggShell] = backgroundColor === 'eggShell',
        _b[styles.active] = isActive,
        _b), className);
    return (React.createElement(Typography, __assign({ ref: linkRef, styleAs: "paragraphHeading", element: Component, noMargins: true, className: classNames, "data-test": "nav-link" }, props), label || children));
};
export var NavLink = NavLinkComponent;
//# sourceMappingURL=NavLink.js.map